import { ActivitiesFormIngredientSupplier } from "./Activities.type";

type ActivityData = NonNullable<ActivitiesFormIngredientSupplier["ingredientSupplierActivityDatas"]>[number];

export const getActivityDataOrganizationId = (activityData: ActivityData): number | undefined => {
    if (!("organization" in activityData)) {
        return undefined;
    }

    return activityData.organization.id;
};
